import http from '../utils/http';
import axios from 'axios';
const baseRoute = '/laudo';

export default {
    getInformacoesByIdLaudo(idLaudo) {
        return http.get({
            url: baseRoute + `/informacoes/${idLaudo}`,
            lockScreen: true,
            lockMessage: 'Buscando informações do laudo'
        });
    },

    cadastrarLaudos(body = {}) {
        return http.post({
            url: baseRoute + '/cadastrar',
            data: body,
            lockScreen: true,
            lockMessage: 'Cadastrando laudo'
        });
    },

    requestLaudos(body, { page, size, sort }) {
        return http.post({
            url:
                baseRoute +
                `/filtrar?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando laudos'
        });
    },

    getSituacoesPossiveis() {
        return http.get({
            url: baseRoute + '/situacao',
            lockScreen: false
        });
    },

    getStatusPossiveis() {
        return http.get({
            url: baseRoute + '/status',
            lockScreen: false
        });
    },

    sendResultados(body) {
        return http.post({
            url: baseRoute + '/finalizar',
            data: body,
            lockScreen: true,
            lockMessage: 'Salvando resultado do laudo'
        });
    },

    getCulturas() {
        return http.get({
            url: baseRoute + '/culturas',
            lockScreen: false
        });
    },

    getTipoLaudo() {
        return http.get({
            url: baseRoute + '/tipo-laudo',
            lockScreen: false
        });
    },

    downloadLaudo(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/download/${id}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando laudo para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    downloadArquivoLaudo(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/download-arq-laudo/${id}`,
                    responseType: 'blob'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    getRepresentantes(query = '') {
        return http.get({
            url: baseRoute + `/representantes?query=${query}`,
            lockScreen: false
        });
    },

    getCredores(query = '') {
        return http.get({
            url: baseRoute + `/credores?query=${query}`,
            lockScreen: false
        });
    },

    getTerritorios(query = '') {
        return http.get({
            url: baseRoute + `/territorios?query=${query}`,
            lockScreen: false
        });
    },

    getCar(query = '') {
        return http.get({
            url: baseRoute + `/car?query=${query}`,
            lockScreen: false
        });
    },

    exportXlsx(idTipoLaudo) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/xlsx/${idTipoLaudo}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    baixarShape(id) {
        return http.get({
            url: baseRoute + `/${id}/shape`,
            responseType: 'blob',
            lockScreen: true,
            lockMessage: 'Preparando shape para download'
        });
    },
    removerArquivoTemp(nomeArquivo) {
        return http.delete({
            url: baseRoute + '/remover-arq-temp',
            data: { nomeArquivo }
        });
    },

    vincularAnalista(idLaudo) {
        return http.get({
            url: baseRoute + `/${idLaudo}/vincular-analista`,
            lockScreen: true,
            lockMessage: 'Vinculando analista ao laudo'
        });
    },

    uploadResultadoConformidade(laudoId, tipoInsumo, arquivo) {
        let formData = new FormData();
        formData.append('file', arquivo);

        formData.append('laudoId', laudoId);
        formData.append('tipoInsumo', tipoInsumo);

        let url =
            process.env.VUE_APP_HTTP_PATH + baseRoute + '/upload-conformidade';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    uploadResultadoLaudo(arquivoComResultado, laudoId, status) {
        const formData = new FormData();

        const url = process.env.VUE_APP_HTTP_PATH + '/laudo/finalizar';

        formData.append('file', arquivoComResultado.raw);

        formData.append('laudoId', laudoId);
        formData.append('statusId', status);
        axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    atualizarGeometria(body) {
        return http.post({
            url: baseRoute + '/atualizar-geometria',
            data: body,
            lockScreen: true,
            lockMessage: 'Atualizando laudo'
        });
    }
};
